<template>
  
  <v-row no-gutters>
    <v-col cols="6">
      <v-sheet>
      <v-col cols="4">
         <FormBuilder :formElements="formElements" @formSubmit="fn">
                     <v-col cols="12">
            <DateTimePickerFilter
              :error="dateErrors"
              :blockedIntervals="blockedIntervals"
              v-model="dateObj"
            ></DateTimePickerFilter>
          </v-col>
           </FormBuilder>
    </v-col>
    </v-sheet>
    </v-col>
  </v-row>
  

</template>

<script>
import DateTimePickerFilter from '@/components/v2/DateTimePickerFilter'
import ProbeCalibrationValuesInput from '@/components/v2/customInputs/ProbeCalibrationValuesInput'
import httpClient from '@/api/httpClient'
export default {
  components: {
    ProbeCalibrationValuesInput,
    DateTimePickerFilter
  },
  methods: {
    fn(item) {
      httpClient({
        url: '/reports/DeltaCustomMonthlyCalculation',
        method: 'POST',
        responseType: 'blob', // important,
        data: item
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    }
  },
  data() {
    return {
      dateErrors: '',
      blockedIntervals: [],
      dateObj: {},
      ids: [],
      vehicles: [],
      choosenVehicle: {},
      formElements: [
        {
          key: 'omvFilePath',
          component: 'v-image-upload',
          label: '$omv',
          props: {
            multiple: false,
            uploadType: 1,
            alowedFileTypes: ['xlsx', 'xls'],
            alowedFileSize: 123000,
            label: 'Icon file',
            uploadFolder: 'icons',
            rules: 'required|ext:xls,xlsx'
          }
        },
        {
          key: 'deltaFilePath',
          component: 'v-image-upload',
          label: '$delta',
          props: {
            multiple: false,
            uploadType: 1,
            alowedFileTypes: ['xlsx', 'xls'],
            alowedFileSize: 123000,
            label: 'Icon file',
            uploadFolder: 'icons',
            rules: 'required|ext:xls,xlsx'
          }
        }
      ]
    }
  },
  async mounted() {
    httpClient
      .get('/vehicles?withFuelTankVolume=true&useProbe=true')
      .then(result => {
        this.vehicles = result.data
      })
  },
  watch: {
    choosenVehicle: {
      handler() {
        console.log(this.choosenVehicle)
      }
    }
  }
}
</script>
<style>
</style>
